import React from 'react';
import { LabelText } from '../../components/Language/LabelText';
import HeaderTitle from '../../hoc/HeaderTitle';
import './index.css';

function AuditOverviewHeaderTitle() {   
    return (        
      <HeaderTitle className = "audit-overview-header-code-row row">
        <span className="audit-overview-header-title-align">
          <LabelText tid="audit" />
        </span>
      </HeaderTitle>        
    )
}

export default AuditOverviewHeaderTitle;